import { useCallback, useEffect, useMemo, useState } from 'react';
import ManagerHoursForm from './ManagerHoursForm.js';
import Loader from '../Loader/Loader.js';
import { StyledText } from '../../atoms/Text/StyledText.js';
import { StyledLoaderWrapper } from '../../../styles/sharedStyles.js';
import { getString } from '../../../strings/index.js';
import { hasPermission } from '../../../logic/permissions.js';
import {
    listManagerHoursTypes,
    listManagers,
    createOwnManagerHour,
    createManagerHourForUser,
} from '../../../logic/requests/employees';

const TrackManagerHours = ({ user }) => {
    const [managers, setManagers] = useState();
    const [types, setTypes] = useState();
    const [err, setErr] = useState(false);

    const canManageAll = useMemo(() => hasPermission(user, 'can_manage_all_manager_hours'), [user]);

    useEffect(() => {
        listManagerHoursTypes()
            .then((res) => {
                setTypes(res);
            })
            .catch((err) => {
                console.error('listManagerHoursTypes', err);
                setErr(true);
                setTypes([]);
            });

        if (canManageAll) {
            listManagers()
                .then((res) => {
                    setManagers(res);
                })
                .catch((err) => {
                    console.error('listManagers', err);
                    setErr(true);
                    setManagers([]);
                });
        } else {
            setManagers([]);
        }
    }, [canManageAll]);

    const isLoading = !types || (canManageAll && !managers);

    const handleSubmit = useCallback(
        (formData, onSuccess, onError) => {
            const request = canManageAll
                ? createManagerHourForUser({
                      type: formData.type,
                      hours: formData.hours,
                      date: formData.date,
                      description: formData.description,
                      id_User: formData.manager,
                  })
                : createOwnManagerHour({
                      type: formData.type,
                      hours: formData.hours,
                      date: formData.date,
                      description: formData.description,
                  });

            request.then(onSuccess).catch((err) => {
                console.error('createManagerHour', err);
                onError(err);
            });
        },
        [canManageAll]
    );

    return (
        <>
            <StyledText
                hasdeclaredfontsize="22px"
                hasdeclaredfontweight="700"
                hasdeclaredtextalign="center"
                hasdeclaredtexttransform="uppercase"
                hasdeclaredmargin="clamp(30px, 4vw, 80px) 0 20px 0"
            >
                {getString('User_panel_trainer_track_hours_add_manager_hours')}:
            </StyledText>
            {isLoading ? (
                <StyledLoaderWrapper>
                    <Loader />
                </StyledLoaderWrapper>
            ) : err ? (
                <StyledLoaderWrapper>
                    <StyledText
                        hasdeclaredpadding="0px 20px"
                        hasdeclaredfontsize="22px"
                        hasdeclaredfontweight="700"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                        as="p"
                    >
                        {getString('blad_wczytywania')}
                    </StyledText>
                </StyledLoaderWrapper>
            ) : (
                <ManagerHoursForm
                    user={user}
                    types={types}
                    managers={managers}
                    onSubmit={handleSubmit}
                />
            )}
        </>
    );
};

export default TrackManagerHours;
